import React from 'react';
import { format } from 'date-fns';
import * as Stats from '@components/StatsCard';
import InsightsWrapper from '@components/Graphs/DataWrapper';
import StackedColourGraph from '../../StackedColourGraph';
import { useInsightsDate } from '@services/InsightsDateProvider';
import { colourScheme, isPreliminary } from '../../utils';

import styles from '../Cards.module.scss';

export const ProfileViewsPerformanceCard = ({ shopIds }) => {
	const { startDate, endDate, selectedRange, interval } = useInsightsDate();
	const query = {
		table: 'gmb',
		from: format(startDate, 'yyyy-MM-dd'),
		to: format(endDate, 'yyyy-MM-dd'),
		id: shopIds,
		interval,
		columns: ['map_views_desktop', 'map_views_mobile', 'search_views_desktop', 'search_views_mobile', 'date'],
		sort: [{ column: 'date', order: 'asc' }],
		sum: ['map_views_desktop', 'map_views_mobile', 'search_views_desktop', 'search_views_mobile']
	};

	return (
		<Stats.Card className={`${styles.card} ${styles.businessProfile}`}>
			<Stats.Title>Maps and Search views</Stats.Title>
			<Stats.Subtitle>{selectedRange}</Stats.Subtitle>
			<InsightsWrapper query={query} hideError>
				{(data) => {
					const series = [
						{
							label: 'Views on Google Search',
							dataset: data.map((insight) => ({
								label: new Date(insight['date']),
								value: insight['search_views_desktop'] + insight['search_views_mobile'],
								preliminary: isPreliminary(
									insight['search_views_desktop'] + insight['search_views_mobile'],
									insight['date']
								)
							}))
						},
						{
							label: 'Views on Google Maps',
							dataset: data.map((insight) => ({
								label: new Date(insight['date']),
								value: insight['map_views_desktop'] + insight['map_views_mobile'],
								preliminary: isPreliminary(insight['map_views_desktop'] + insight['map_views_mobile'], insight['date'])
							}))
						}
					].map((obj, i) => {
						obj.backgroundColor = colourScheme[i];
						return obj;
					});

					return (
						<div className={styles.maxGraphWrapper}>
							<StackedColourGraph className={styles.maxGraph} series={series} />
						</div>
					);
				}}
			</InsightsWrapper>
		</Stats.Card>
	);
};
